import { call, put } from 'redux-saga/effects';
import { MESSAGES } from 'appconstants';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import {
  SYMMETRICKEYS,
  NOTIFICATION,
} from '../actionTypes';

const fetchSymmetrickey = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SYMMETRICKEYS}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SYMMETRICKEYS}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SYMMETRICKEYS}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.SYMMETRICKEYS}${query}${sorting}`);
};

export function* getSymmetrickey(action) {
  try {
    const { data: { entity } } = yield call(fetchSymmetrickey, action.payload);
    yield put({ type: SYMMETRICKEYS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: SYMMETRICKEYS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
